<div class="terms" [class.--is-desktop]="isDesktop">
  <h1 *ngIf="pathsURL[this.currentPath].title">{{ pathsURL[this.currentPath].title | translate }}</h1>
  <div *ngIf="!loadingDoc" class="__doc-container" [innerHTML]="docHtml"></div>
  <mip-loading *ngIf="loadingDoc"></mip-loading>
</div>
